module.exports = __webpack_public_path__ + "media/assets/images/category/ValentinesDay@2x-995e49856324ae3e0fa18fc0bbe67cd9.png";